import { ChevronDown, ChevronRight } from 'lucide-react'

/**
 * The disclosure glyph of a row or a section that folds: right while shut,
 * down while open. One glyph, so every foldable thing in the app turns the
 * same way.
 */
export function FoldChevron({
  open,
  size = 16,
}: {
  open?: boolean
  /** Edge length in pixels. */
  size?: number
}) {
  const className = 'shrink-0 text-muted-foreground'
  return open ? (
    <ChevronDown size={size} className={className} aria-hidden />
  ) : (
    <ChevronRight size={size} className={className} aria-hidden />
  )
}
